import { Behavior } from "../../base/Behavior";
import { CrudDecorator } from "./CrudDecorator";
import { DataHeader } from "../../components/dataheader/DataHeader";

export class CrudDecoratorBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public insertDataHeader(decorator: CrudDecorator, dataHeader: DataHeader) {
        decorator.insert(dataHeader, 0);
    }

    get type(): string {
        return "CrudDecorator";
    }
}

CrudDecoratorBehavior.register();
